'use client';

import type { BlogArticleDocument } from '../../../../../../prismicio-types';
import { ArticlesList, Container } from '@/components';
import { Article } from './Article/Article';

import styles from './blogArticleInner.module.scss';
import './main.scss';

import { useVisible } from '@/hooks';

interface BlogArticleInnerProps {
  page: BlogArticleDocument<string>;
  articles: BlogArticleDocument<string>[];
}

export const BlogArticleInner = ({ page, articles }: BlogArticleInnerProps) => {
  const [isVisibleHeading, headingId] = useVisible();
  return (
    <div>
      <Container styles={styles.container}>
        <Article page={page} />
        <div
          id={headingId}
          className={`${styles.title_wrapper} ${isVisibleHeading ? styles.isVisible : ''}`}
        >
          <h2 className={styles.title}>Explore guidance</h2>
        </div>
        <ArticlesList articles={articles} baseUrl="" />
      </Container>
    </div>
  );
};
